import form from './form.ejs'
import builder from './builder.ejs'
export default { form, builder }
